import { render, staticRenderFns } from "./examen-para.html?vue&type=template&id=70ac236d&scoped=true&external"
import script from "./examen-para.js?vue&type=script&lang=js&external"
export * from "./examen-para.js?vue&type=script&lang=js&external"
import style0 from "./examen-para.scss?vue&type=style&index=0&id=70ac236d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac236d",
  null
  
)

export default component.exports